import React from 'react';
import { PiHeart, PiLeaf, PiUsersThree } from 'react-icons/pi';
import AnimateIn from './AnimateIn';

const PRINCIPLES = [
  { title: 'People first', text: 'We design for real needs, real people and real moments in everyday life.', Icon: PiUsersThree, tone: 'violet' },
  { title: 'Practical by design', text: 'Useful, focused products that solve genuine problems without unnecessary complexity.', Icon: PiLeaf, tone: 'green' },
  { title: 'A kinder internet', text: 'We believe technology can be a positive force – more helpful, more considerate and more human.', Icon: PiHeart, tone: 'pink' },
];

const Vision = () => (
  <section id="company" className="bg-[#031a3d] px-6 py-16 text-white md:px-12 lg:px-16 lg:py-20">
    <div className="mx-auto max-w-[90rem]">
      <AnimateIn variant="fade-up">
        <p className="eyebrow-light text-violet-light">Our principles</p>
        <div className="mt-4 h-1 w-16 bg-violet" />
      </AnimateIn>
      <div className="mt-10 grid md:grid-cols-3">
        {PRINCIPLES.map(({ title, text, Icon, tone }, index) => (
          <AnimateIn key={title} variant="fade-up" delay={index * 80} className="border-b border-white/20 py-8 last:border-b-0 md:border-b-0 md:border-r md:px-10 md:first:pl-0 md:last:border-r-0">
            <div className="principle-icon" data-tone={tone}><Icon aria-hidden="true" /></div>
            <h3 className="mt-5 text-xl font-bold tracking-[-0.025em]">{title}</h3>
            <p className="mt-3 max-w-sm text-sm leading-6 text-white/70 md:text-base">{text}</p>
          </AnimateIn>
        ))}
      </div>
    </div>
  </section>
);

export default Vision;
